import { Route, Routes } from "react-router-dom";
import PrivateRoute from "../packages/common-utilities/app-documents/private.route";
import { appSlugs, tokenMainKeys } from "../utils/constants";
import { Home } from "../packages/common-utilities/app-documents/Home";

const TrainingManualRoutes = () => {
  return (
    <Routes>
      <Route
        exact
        path="/"
        element={
          <PrivateRoute
            tokenKey={tokenMainKeys.trainingManual}
            slug={appSlugs.trainingManual}
          />
        }
      >
        <Route
          path="/"
          element={
            <Home
              tokenKey={tokenMainKeys.trainingManual}
              slug={appSlugs.trainingManual}
            />
          }
        />
      </Route>
    </Routes>
  );
};

export default TrainingManualRoutes;
